import _regeneratorRuntime from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/inherits.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.push.js";
import { __decorate } from "tslib";
import { getcustomizedBannerList } from '@/services/http';
import { Component, Vue } from 'vue-property-decorator';
import Header from '@/common/header.vue';
import Footer from '@/common/footer.vue';
import BackTop from '@/common/backtop.vue';
import { readCookie } from '@/tools/tools';
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    var _this;
    _classCallCheck(this, default_1);
    _this = _callSuper(this, default_1, arguments);
    // 耗材定制轮播图
    _this.bannerList = [];
    // 代打印轮播图
    _this.customizedList = [];
    return _this;
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "created",
    value: function created() {
      this.getBannerList();
    }
  }, {
    key: "getBannerList",
    value: function () {
      var _getBannerList = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var anchor, res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              anchor = readCookie('anchor');
              _context.next = 3;
              return getcustomizedBannerList({
                channel: 1,
                companyId: 1,
                model: anchor ? anchor.model : '',
                equipVersion: anchor ? anchor.equipVersion : '',
                equipMeid: anchor ? anchor.equipMeid : ''
              });
            case 3:
              res = _context.sent;
              this.bannerList = res.data.data.InsteadBananList;
              this.customizedList = res.data.data.customizeBananList;
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getBannerList() {
        return _getBannerList.apply(this, arguments);
      }
      return getBannerList;
    }()
  }, {
    key: "goDetails",
    value: function goDetails(id, type) {
      this.$router.push("/consumables-details?id=".concat(id, "&type=").concat(type, "&from=carousel"));
    }
  }]);
}(Vue);
default_1 = __decorate([Component({
  components: {
    Header: Header,
    Footer: Footer,
    BackTop: BackTop
  }
})], default_1);
export default default_1;